import { connect } from 'react-redux'
import React, { Component } from 'react'
import { createAction } from 'redux-actions'
import VideoItem from './videoItem/VideoItem'
import VideoListHeader from './VideoListHeader'
import VideoCreator from './VideoCreator'
import Pagination from '../../misc/Pagination'
import { fetchVideos, SELECT, DESELECT, DESELECT_ALL, ZOOM } from '../../actions'
import './videoList.css'
import { isMobile, isIOs, getVideosAndPending, getAllShortcodes } from '../../misc/selectors'
import AnimatedLogo from '../../assets/logo.gif'
import debounce from 'lodash/debounce'
import ZoomOverlay from './ZoomOverlay'

const mapStateToProps = (state, ownProps) => {
  const { videos, me } = state
  const { groupId } = ownProps

  return {
    me,
    isIOs: isIOs(state),
    pro: me.pro,
    selected: me.selected,
    pages: Math.ceil(videos.total / videos.count),
    // don't return uploads on albums because we don't know which album they're in
    items: getVideosAndPending(state),
    group: me.groups.find(x => x.id === groupId),
    group_id: groupId || null,
    isFetching: videos.isFetching,
    isMobile: isMobile(state),
  }
}

const mapDispatchToProps = (dispatch, ownProps) => ({
  dispatch,
  select: (shortcode) => {
    dispatch(createAction(SELECT)(shortcode))
  },
  deselect: (shortcode) => {
    dispatch(createAction(DESELECT)(shortcode))
  },
  deselectAll: (shortcode) => {
    dispatch(createAction(DESELECT_ALL)(shortcode))
  },
  closeZoom: () => {
    dispatch(createAction(ZOOM)())
  },
})

class VideosList extends Component {
  constructor() {
    super()
    this.state = {
      sort: 'date_added',
      sortd: 'DESC',
      count: 12,
      page: 1,
      search: null,
      group_id: null,
      tag: null,
      playerMuted: true,
      currentSearch: null,
      canShowWelcome: false,
    }

    this.dispatchFetch = this.dispatchFetch.bind(this)
    this.dispatchFetchDebounced = debounce(this.dispatchFetch, 500, { leading: true, trailing: true })
  }

  dispatchFetch(options) {
    this.setState({ currentSearch: options.search })
    this.props.dispatch(fetchVideos(options))
  }

  fetch(options = {}, force = false, debounced = false) {
    const processedOptions = {
      ...this.state,
      ...options,
      force,
    }

    if (processedOptions.group_id) {
      Reflect.deleteProperty(processedOptions, 'sort')
      Reflect.deleteProperty(processedOptions, 'sortd')
    }

    this.setState(options)
    if (debounced) {
      this.dispatchFetchDebounced(processedOptions)
    } else {
      this.dispatchFetch(processedOptions)
    }
  }

  componentWillMount() {
    this.fetch({ group_id: this.props.group_id, tag: this.props.tag })

    setTimeout(() => {
      this.setState({ canShowWelcome: true })
    }, 500)
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.group_id !== this.props.group_id) {
      this.fetch({
        group_id: nextProps.group_id,
        sort: 'date_added',
        sortd: 'DESC',
        count: 12,
        page: 1,
        search: null,
        tag: null,
      })
    }
    if (nextProps.tag !== this.props.tag) {
      this.fetch({
        group_id: null,
        sort: 'date_added',
        sortd: 'DESC',
        count: 12,
        page: 1,
        search: null,
        tag: nextProps.tag,
      })
    }
  }
  isSelected(video) {
    return this.props.selected.contains(video.shortcode)
  }

  render() {
    return (
      <div>
        <div className="videos-list">
          <VideoCreator groupId={this.props.group} />
          <VideoListHeader
            onChange={() => this.fetch({}, true)}
            onSearchChanged={(search) => {
              this.fetch({ search }, false, true)
            }}
            onSortChanged={(sort, sortd) => {
              this.fetch({ sort, sortd })
            }}
            {...this.props}
            {...this.state}
          />
          <div
            className={
              `grid row videos-list-items ${this.props.items.length ? '' : 'empty'}`
            }
          >
            {this.props.items.map((video, i) => (
              <VideoItem
                me={this.props.me}
                key={video.shortcode || video.local_id}
                selectableKey={video.shortcode || video.local_id}
                type='grid'
                video={video}
                selected={this.isSelected(video)}
                group={this.props.group}
                onSelect={() => {
                  this.props.select(video.shortcode || video.local_id)
                }}
                onDeselect={() => {
                  this.props.deselect(video.shortcode || video.local_id)
                }}
                isMobile={isMobile}
              />
            ))}
          </div>
          {this.props.isFetching === false && !this.props.items.length && this.state.currentSearch === this.state.search
            ? this.state.currentSearch
                ?
                  <div className="video-list-placeholder">No videos match your search</div>
                :
                  this.state.canShowWelcome ?
                    <div className="row video-list-placeholder-container">
                      <div className="video-list-placeholder">
                        <h2>Welcome.</h2>
                        <span>
                          To get started, upload a video using the button above or enter the URL of a video you'd like to clip.
                        </span>
                        <div className="embed-container card">
                          <div
                            style={{
                              width: '100%',
                              minHeight: '300px',
                              position: 'relative',
                              paddingBottom: '56.250%',
                            }}
                          >
                            <iframe
                              src="//streamable.com/e/bwkxc"
                              frameBorder="0"
                              allowFullscreen
                              webkitallowfullscreen
                              mozallowfullscreen
                              scrolling="no"
                              style={{
                                width: '100%',
                                height: '100%',
                                position: 'absolute',
                                left: '0px',
                              }}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                : ''
            : ''}
          {this.props.pages > 1
            ? <div className="col-12">
              <Pagination
                page={this.state.page}
                pages={this.props.pages}
                onChange={(page) => {
                  this.fetch({ page })
                }}
              />
            </div>
            : ''}
          {this.props.isFetching === true || this.state.currentSearch !== this.state.search
            ? <div className="loading-indicator">
              <img src={AnimatedLogo} alt="presentation" />
            </div>
            : ''}
          {this.props.me.zoomed
            ? 
              <ZoomOverlay
                me={this.props.me}
                video={this.props.me.zoomed}
                onClose={this.props.closeZoom}
                isMobile={this.props.isMobile}
              />
            : ''}
        </div>
      </div>
    )
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(VideosList)
